import { AuthFlow } from '@griply/types';
import {
  CaptureAuthError,
  reportAuthFailure,
  toAuthFlowError,
} from '@griply/utils';
import { getErrorReporter } from 'shared/services/error-tracking';

const captureException: CaptureAuthError = (cause, report) => {
  getErrorReporter().captureException(cause, report);
};

export const handleAuthError = (
  error: unknown,
  flow: AuthFlow,
  extra?: Record<string, unknown>,
) => toAuthFlowError(error, flow, captureException, extra);

export const reportAuthError = (
  error: unknown,
  flow: AuthFlow,
  extra?: Record<string, unknown>,
) => reportAuthFailure(error, flow, captureException, extra);
